export default __webpack_public_path__ + "static/media/lock-icon.a90a6358.svg";